export default __webpack_public_path__ + "static/media/url-string.9b915402.jpg";